export const BASE_WEB_URL = process.env.REACT_APP_WEB_URL;
